import { render, staticRenderFns } from "./box-shadow-bottom.vue?vue&type=template&id=226915f4&scoped=true&"
import script from "./box-shadow-bottom.vue?vue&type=script&lang=js&"
export * from "./box-shadow-bottom.vue?vue&type=script&lang=js&"
import style0 from "./box-shadow-bottom.vue?vue&type=style&index=0&id=226915f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226915f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226915f4')) {
      api.createRecord('226915f4', component.options)
    } else {
      api.reload('226915f4', component.options)
    }
    module.hot.accept("./box-shadow-bottom.vue?vue&type=template&id=226915f4&scoped=true&", function () {
      api.rerender('226915f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common-page/country-proj/components/box-shadow-bottom.vue"
export default component.exports